export const environment = {
  production: false,
  apiBaseUrl: 'https://killer-api.staging.chaton.games',
  clerkPublishableKey: 'pk_test_cHJvbXB0LW1hbGFtdXRlLTExMDEuY2xlcmsuYWNjb3VudHMuZGV2JA',
  // Page de recuperation de token Clerk longue duree : locale uniquement.
  devTokenTemplate: null as string | null,
  // Widget Turnstile de cet environnement a creer (roadmap, lot 15) : inscription impossible tant que null.
  turnstileSiteKey: '0x4AAAAAAFl_0BwY4h5N9E0n' as string | null,
};
